export const menu = [
    {
        icon: "",
        title: "Total Net Farmer Benefits",
        items: [
            {
                icon: "",
                title: "Total Indemnities"
            },
            {
                icon: "",
                title: "Total Farmer Paid Premium"
            },
            {
                icon: "",
                title: "Total Premium"
            },
            {
                icon: "",
                title: "Total Premium Subsidy"
            }
        ]
    },
    {
        icon: "",
        title: "Loss Ratio"
    },
    {
        icon: "",
        title: "Liabilities"
    },

    {
        icon: "",
        title: "Total Policies Earning Premium"
    },

    {
        icon: "",
        title: "Insured Area in Acres"
    }
];
